module.exports = __webpack_public_path__ + "img/logoxiao.c2808c9c.png";